import TableFilterType from '../../../helpers/types/tableFilterType';

const filters: TableFilterType[] = [];

export default filters;
